import React from 'react'

export const Converse = ({ width, height, fill }) => {
  return (
    <div>
        <svg
            width={width}
            height={height}
            viewBox="0 0 69 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.174 25.587V12.9545L11.9898 23.1845L0.0702515 19.2282L7.58775 29.462L0.205876 39.692L12.0053 35.7977L19.1934 46.0238V33.3952L31.2446 29.4427L19.174 25.587ZM68.929 29.5395L42.5054 58.5633H19.8134L46.2602 29.5395L19.8134 0.438278H42.5054L68.929 29.5395Z"
                fill={fill}
            />
        </svg>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/assets/Converse.js